import React, { Component } from 'react';
import PropTypes from 'prop-types';

import components from './parts/parts-map';

class PeopleSingle extends Component {
	static slug = 'fl_people_single';
	static propTypes = {
		element: PropTypes.string.isRequired,
	};

	render() {
		const personConfig = window.et_person_config;
		if (!personConfig) {
			return null;
		}
		if (typeof this.props.element === 'undefined' || !this.props.element) {
			return null;
		}
		const Tag = components[this.props.element];
		return <Tag data={personConfig} moduleProps={this.props} />;
	}
}

export default PeopleSingle;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/people-single.js